import {
  SET_APARTMENT_MODAL,
  SET_APARTMENT_MODAL_REMOVE_TENANT,
  SET_APARTMENT_MODAL_UPDATE_TENANT,
  SET_APARTMENT_MODAL_UPDATE_APARTMENT_OWNER,
  SET_APARTMENT_MODAL_UPDATE_LEASES,
} from 'redux/actions/types.js' // eslint-disable-line

const defaultState = {
  apartment: null,
  open: false,
}

const apartmentModal = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_APARTMENT_MODAL:
      return {
        ...state,
        ...payload,
      }
    case SET_APARTMENT_MODAL_REMOVE_TENANT:
      return {
        ...state,
        ...{
          apartment: {
            ...state.apartment,
            ...payload,
          },
        },
      }
    case SET_APARTMENT_MODAL_UPDATE_APARTMENT_OWNER:
      return {
        ...state,
        ...payload,
      }
    case SET_APARTMENT_MODAL_UPDATE_TENANT:
      return {
        ...state,
        ...{
          apartment: {
            ...state.apartment,
            ...{ leases: payload },
          },
        },
      }
    case SET_APARTMENT_MODAL_UPDATE_LEASES:
      return {
        ...state,
        ...{
          apartment: payload,
        },
      }
    default:
      return {
        ...state,
      }
  }
}
export default apartmentModal
